<template>
  <section class="grid-flex">
    <section class="flex column w100">
      <div class="flex-1 flex row w100 middle">
        <div class="flex-1 w100">
          <div class="flex flex-1  middle">
            <router-link
                :to="{
                  name: 'CustomConversionNew',
                  params: { },
                }"
              >
              <div class="button primary">

                Criar Conversão Personalizada
              </div>
            </router-link>
            <div class="flex column" style="margin-left: 16px">
              Quantidade de Conversões: {{ account.used_limits.limit_custom_conversion | number }} / {{ account.plan_limits.limit_custom_conversion | number }}
              <div class="margin-top-s">Precisa de mais Conversões? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
            </div>
          </div>
        </div>
        <div class="flex-1 flex end filters-groupo-holder">
          <div v-if="FinalizationRegistry" class="flex between middle">
            <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
          </div>
        </div>
      </div>
      <div class="flex w100 end">
        <div class="filters-groupo-holder">
          <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
      <div class="list-itens flex column w100">
        <div
          class="box flex-1 w100"
          v-for="(cc, index) in customConversions"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <p>
                      <b>
                        {{ cc.name }}
                      </b>
                    </p>
                    <div class="margin-top-s">
                      {{ cc.platform }}
                    </div>
                  </div>
                  <div class="flex-2 flex ">
                    <div class="flex-1 flex details between">
                      <div v-if="false" class="flex column">
                        <div>
                          Ações
                        </div>
                        <div class="margin-top-s">
                          {{ 0 | number }}
                        </div>
                      </div>
                    </div>
                    <!-- stats -->
                    <div v-if="false" class="flex-1">
                      <div>
                        Disparos
                      </div>
                      <div class="margin-top-s">
                        {{ getClicks(cc.id) | number }}
                      </div>
                    </div>
                    </div>
                </div>
              </div>
              <div class="action">
                <div class="flex end">
                  <router-link
                    :to="{
                      name: 'CustomConversionEdit',
                      params: { conv_id: cc.id },
                    }"
                  >
                    <div class="button primary">
                      EDITAR
                    </div>
                  </router-link>
                  <div
                    class="button primary"
                    @click="openToDelete(cc)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum Conversões Personalizada criada. Crie seu primeiro Conversões Personalizada para ter
            seus rastreamentos.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newCustomConversion.name"
                autocomplete="off"
              />
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrupdateCustomConversion()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Conversões Personalizada?"
      @cancel="
        showModalDelete = false;
        selectedCustomConversion = null;
      "
      @accept="deleteCustomConversion(selectedCustomConversion.id)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import {
  getCustomConversions,
  getCustomConversionsReport,
  deleteCustomConversion,
} from "@/services/customConversion";

const EMPTY_CUSTOM_CONVER = {
  name: "",
};

export default {
  name: "custom-conversion",
  components: {
    Modal,
    ModalConfirm,
    ltkDatePicker,
  },
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedCustomConversion: null,
      newCustomConversion: Object.assign({}, EMPTY_CUSTOM_CONVER),
      customConversions: [],
      reportcustomConversions: {},
      totalCustomConversion: 0,
      offset: 20,
      page: 1,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
      openUtmFields: false,
    };
  },
  mounted() {
    this.getCustomConversions();
    this.getCustomConversionsReport();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.customConversions = [];
        this.reportcustomConversions = {};
        this.getCustomConversions();
        this.getCustomConversionsReport();
      },
    },
    page: {
      handler() {
        this.customConversions = [];
        this.getCustomConversions();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Conversao': 'Criar Conversão'
    },
    isEmpty() {
      return this.totalCustomConversion === 0 && !this.loading;
    },
    isEdit() {
      if (this.newCustomConversion && this.newCustomConversion.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalCustomConversion % this.offset;
      let value = this.totalCustomConversion / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_custom_conversion <= this.account.used_limits.limit_custom_conversion) {
        return true
      }

      return false
    },
  },
  methods: {
    getClicks(shId) {
      if (!this.reportcustomConversions[shId]) {
        return '-'
      }

      return this.reportcustomConversions[shId]['clicks']
    },
    openToDelete(cc) {
      this.showModalDelete = true;
      this.selectedCustomConversion = cc;
    },
    getCustomConversions() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };
      getCustomConversions(params)
        .then((result) => {
          this.customConversions = result.custons;
          this.totalCustomConversion = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomConversionsReport() {
      this.loadingReport = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };

      getCustomConversionsReport(params)
        .then((result) => {
          this.reportcustomConversions = result.logs
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loadingReport = false;
        });
    },
    deleteCustomConversion(shortId) {
      deleteCustomConversion(shortId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conversão Personalizada deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedCustomConversion = null;
          this.showModalDelete = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

</style>
